const getIsSignedIn = state => state?.user?.response?.isSignedIn;

export default getIsSignedIn;
